import { render, staticRenderFns } from "./Lianbao.vue?vue&type=template&id=22171a48&scoped=true&"
import script from "./Lianbao.vue?vue&type=script&lang=js&"
export * from "./Lianbao.vue?vue&type=script&lang=js&"
import style0 from "./Lianbao.vue?vue&type=style&index=0&id=22171a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22171a48",
  null
  
)

export default component.exports